import React from 'react';
import { motion } from 'framer-motion';
export function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} data-id="element-226">
      {children}
    </motion.div>;
}